// API Configuration - Simplified for production
// All API calls go to /api/* which Firebase Hosting rewrites to Cloud Functions

// For production on startskipres.com, we use relative URLs (/api/...)
// For development, we use the full Cloud Functions URL

const isProduction = typeof window !== 'undefined' && 
  (window.location.hostname === 'startskipres.com' || 
   window.location.hostname === 'www.startskipres.com');

// In production, use empty string so URLs become relative like /api/admin/stats
// In development, use the full Firebase Functions URL
export const API_URL = isProduction 
  ? '' 
  : 'https://us-central1-start-skipres.cloudfunctions.net/api';

export default API_URL;
